import { useEffect, useRef } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../components/loader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { enterPrisesPaths } from "../../routes/enterprises";
import { useDispatch, useSelector } from "react-redux";
import { coachPaths } from "../../routes/coach";

const ExploreService = () => {
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const { categoryList, isLoading } = useSelector((state) => state.coach.auth);

  const user = { name: "find-a-coach", role: "coach" };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const { state } = useLocation();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  if (isLoading2 || isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <MenuLayout user={user}>
        <section class="ct_workshop_banner ct_px_40 py-4">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div
                class="col-lg-7 mb-4 mb-lg-0"
                data-aos="fade-right"
                data-aos-duration="3000"
              >
                <h2
                  class="ct_fs_50_new mb-4 ct_darkblue_text"
                  style={{ maxWidth: "560px" }}
                >
                  Power Your <span class="ct_yellow_text"> Business </span> with
                  Tailored Services
                </h2>
                <p
                  class="mb-0 ct_fs_20 ct_darkblue_text"
                  style={{ maxWidth: "613px" }}
                >
                  From customer support and sales to marketing, design, and
                  tech. Nuvio connects you to expert services that help you grow
                  smarter and faster.
                </p>
                <div class="ct_mt_40">
                  <a
                    class="ct_yellow_btn px-5 ct_fit_content"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(enterPrisesPaths?.SalesServiceSubscription);
                    }}
                  >
                    View Our Packages
                  </a>
                </div>
              </div>
              <div
                class="col-lg-5 mb-4 mb-lg-0"
                data-aos="fade-left"
                data-aos-duration="1000"
              >
                <div class="ct_workshop_right_img">
                  <img
                    src="../assets/img/services_right_img_1234.png"
                    alt=""
                    style={{ maxWidth: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class=" ct_px_40 ct_py_130">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div
                class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                data-aos="fade-right"
                data-aos-duration="1500"
              >
                <div class="ct_how_work_img">
                  <img
                    src="../assets/img/coach_works_img.png"
                    alt=""
                    style={{ objectFit: "cover", objectPosition: "right" }}
                  />
                </div>
              </div>
              <div
                class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <div class="ct_how_work_content">
                  <h4 class="ct_fs_24 ct_darkblue_text">
                    Transform Your Business with Our Expertise
                  </h4>
                  <h3 class="ct_fs_32 ct_darkblue_text ">
                    Ready to take your business to the next level?
                  </h3>
                </div>
                <div class="row mt-5">
                  <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                    <div class="ct_how_work_card">
                      <img
                        src="../assets/img/sales_icon_pmg.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                      <div class="pt-4">
                        <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                          Sales & Marketing Solutions
                        </h5>
                        <p class="mb-0 ct_fs_16" style={{ maxWidth: "260px" }}>
                          Empower your business with strategic sales and
                          marketing services that drive results and growth.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                    <div class="ct_how_work_card">
                      <img
                        src="../assets/img/raphael_customer.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                      <div class="pt-4">
                        <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                          Customer Engagement & Product Management
                        </h5>
                        <p class="mb-0 ct_fs_16" style={{ maxWidth: "260px" }}>
                          Enhance customer satisfaction and optimize product
                          success with expert management and support.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                    <div class="ct_how_work_card">
                      <img
                        src="../assets/img/mdi_design.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                      <div class="pt-4">
                        <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                          Design & Development
                        </h5>
                        <p class="mb-0 ct_fs_16" style={{ maxWidth: "260px" }}>
                          Create seamless user experiences with cutting-edge web
                          and mobile design solutions tailored to your needs.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="ct_dark_blue_bg rounded-0 ct_py ct_search_dream_job_main">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h4 className="ct_fs_32 ct_mb_30 text-white">
                  Recommended Service
                </h4>
                <div
                  className="ct_search_dream_job_filter ct_flex_col_991"
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <div className="form-group position-relative">
                    <select className="form-control ct_input ct_input_ps_40 ct_h_48 ct_blue_input_bg">
                      <option>Browse by</option>
                      <option>UI/UX Design</option>
                      <option>Mobile App Development</option>
                      <option>Web Development</option>
                      <option>Copy Writing</option>
                      <option>SEO Writing</option>
                      <option>Digital Marketing</option>
                      <option>Social Media Management</option>
                      <option>Product Management</option>
                      <option>Virtual Assistant</option>
                      <option>Customer</option>
                    </select>
                    <div className="ct_input_icon_left">
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_30_38484)">
                          <path
                            d="M16.625 9.50104C16.625 13.4361 13.435 16.626 9.5 16.626C5.56498 16.626 2.375 13.4361 2.375 9.50104C2.375 5.56601 5.56498 2.37604 9.5 2.37604C13.435 2.37604 16.625 5.56601 16.625 9.50104Z"
                            stroke="#FFB703"
                            stroke-width="1.18674"
                            stroke-linejoin="round"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M12.5117 7.46502C13.0258 6.60825 13.2828 6.17985 13.1674 5.97846C13.1325 5.91738 13.0819 5.86674 13.0208 5.83176C12.8194 5.71638 12.391 5.97342 11.5342 6.48749L8.53282 8.28831C8.4653 8.32879 8.43161 8.34903 8.40282 8.37519C8.39317 8.38389 8.38404 8.39302 8.37542 8.4026C8.34918 8.43146 8.32901 8.46515 8.28846 8.53268L6.48768 11.534C5.9736 12.3908 5.71657 12.8191 5.83194 13.0205C5.86693 13.0817 5.91756 13.1323 5.97864 13.1673C6.18003 13.2826 6.60843 13.0257 7.46524 12.5116L10.4666 10.7107C10.534 10.6702 10.5679 10.65 10.5967 10.6239C10.6062 10.6151 10.6154 10.606 10.6241 10.5964C10.6502 10.5676 10.6705 10.5339 10.711 10.4664L12.5117 7.46502ZM9.91909 9.91851C10.151 9.68663 10.151 9.31065 9.91909 9.07878C9.68722 8.84691 9.31124 8.84691 9.07937 9.07878C8.84749 9.31065 8.84749 9.68663 9.07937 9.91851C9.31124 10.1504 9.68722 10.1504 9.91909 9.91851Z"
                            fill="#FFB703"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_30_38484">
                            <rect
                              width="18.9878"
                              height="18.9878"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <div>
                    <h5 className="ct_fs_18 text-white ct_mb_20">
                      Most popular:
                    </h5>
                    <ul className="ct_most_popular_job_list">
                      <li>
                        <a
                          onClick={() =>
                            navigate(enterPrisesPaths?.DesignService)
                          }
                        >
                          Mobile Design
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={() =>
                            navigate(enterPrisesPaths?.customer_service)
                          }
                        >
                          Customer Services
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={() =>
                            navigate(enterPrisesPaths?.SalesService)
                          }
                        >
                          Sales
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={() =>
                            navigate(enterPrisesPaths?.marketing_services)
                          }
                        >
                          Marketing
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="ct_mt_90">
                  <div className="d-flex align-items-center gap-3 justify-content-between ct_mb_40 ct_flex_col_575">
                    <h4 className="ct_fs_36 mb-0 text-white">
                      Recommended Services
                    </h4>
                    <a
                      className="ct_yellow_btn ct_yellow_btn_text_blue  ct_border_radius_8 ct_h_50 ct_white_nowrap"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(coachPaths?.ContactUs, {
                          state: { data: "landing" },
                        });
                      }}
                    >
                      Talk to Us
                    </a>
                  </div>

                  <div className="row gx-xl-5">
                    <div
                      className="col-xl-3 col-lg-3 col-md-6 mb-4 mb-lg-0"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <div className="ct_opportunity_card">
                        <div>
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M26.9499 22.5018C26.4643 22.0237 20.5796 19.7474 19.5118 19.318C18.4496 18.8962 18.0258 17.7271 18.0258 17.7271C18.0258 17.7271 17.5477 17.9915 17.5477 17.249C17.5477 16.5055 18.0258 17.7271 18.504 14.8602C18.504 14.8602 19.8305 14.488 19.5671 11.4102H19.2483C19.2483 11.4102 20.0452 8.11961 19.2483 7.00586C18.4487 5.89211 18.1355 5.14961 16.3796 4.61711C14.6265 4.08555 15.264 4.19149 13.9908 4.24586C12.7158 4.2993 11.6546 4.9893 11.6546 5.35961C11.6546 5.35961 10.8577 5.41305 10.5408 5.7318C10.2221 6.05055 9.69147 7.53555 9.69147 7.9068C9.69147 8.27805 9.95678 10.7755 10.2221 11.3043L9.90616 11.4074C9.64085 14.4862 10.9674 14.8593 10.9674 14.8593C11.4455 17.7262 11.9237 16.5046 11.9237 17.248C11.9237 17.9905 11.4455 17.7262 11.4455 17.7262C11.4455 17.7262 11.0208 18.8943 9.95959 19.3171C8.89834 19.7418 3.0071 22.0237 2.52803 22.5009C2.04991 22.9884 2.10335 25.2159 2.10335 25.2159H13.3871L14.2102 21.9721L13.479 21.2409L14.738 19.9799L15.9971 21.2399L15.2658 21.9712L16.089 25.2149H27.3727C27.3727 25.2149 27.4318 22.9855 26.948 22.499L26.9499 22.5018Z"
                              fill="#FFB703"
                            />
                          </svg>
                        </div>
                        <div className="ct_mt_30">
                          <h4 className="ct_fs_24_new text-white mb-3">
                            Customer Service
                          </h4>
                          <a
                            className="ct_yellow_text"
                            onClick={() =>
                              navigate(enterPrisesPaths?.customer_service)
                            }
                          >
                            View All{" "}
                            <i class="fa-solid fa-arrow-right ms-2"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xl-3 col-lg-3 col-md-6 mb-4 mb-lg-0"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <div className="ct_opportunity_card">
                        <div>
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M22.5044 16.335L25.3294 13.5087C26.3743 12.4642 27.2031 11.224 27.7687 9.8591C28.3343 8.49418 28.6255 7.03121 28.6256 5.55375V1.375H24.4469C22.9695 1.37499 21.5066 1.66597 20.1417 2.23132C18.7767 2.79668 17.5365 3.62534 16.4919 4.67L13.6656 7.495L6.59438 6.61125L1.30062 11.905L18.0944 28.7L23.3881 23.4062L22.5044 16.335ZM20.2644 18.5737L20.7556 22.5025L18.0944 25.1637L15.8844 22.9538L20.2644 18.5737ZM11.4269 9.735L7.04563 14.115L4.83812 11.905L7.49938 9.24375L11.4269 9.735ZM7.04563 21.185L2.62688 25.605L0.859375 23.8375L5.27813 19.4187L7.04563 21.185ZM10.5819 24.7225L6.16188 29.1412L4.39438 27.3737L8.81313 22.9538L10.5819 24.7225Z"
                              fill="#FFB703"
                            />
                          </svg>
                        </div>
                        <div className="ct_mt_30">
                          <h4 className="ct_fs_24_new text-white mb-3">
                            Marketing
                          </h4>
                          <a
                            className="ct_yellow_text"
                            onClick={() =>
                              navigate(enterPrisesPaths?.marketing_services)
                            }
                          >
                            View All
                            <i class="fa-solid fa-arrow-right ms-2"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xl-3 col-lg-3 col-md-6 mb-4 mb-lg-0"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <div className="ct_opportunity_card">
                        <div>
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M23.75 8.125C21.6875 8.125 20 7.5625 20 6.875V8.125C20 8.8125 21.6875 9.375 23.75 9.375C25.8125 9.375 27.5 8.8125 27.5 8.125V6.875C27.5 7.5625 25.8125 8.125 23.75 8.125Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M23.75 6.25C21.6875 6.25 20 5.6875 20 5V6.25C20 6.9375 21.6875 7.5 23.75 7.5C25.8125 7.5 27.5 6.9375 27.5 6.25V5C27.5 5.6875 25.8125 6.25 23.75 6.25ZM23.75 10C21.6875 10 20 9.4375 20 8.75V10C20 10.6875 21.6875 11.25 23.75 11.25C25.8125 11.25 27.5 10.6875 27.5 10V8.75C27.5 9.4375 25.8125 10 23.75 10Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M23.75 11.875C21.6875 11.875 20 11.3125 20 10.625V11.875C20 12.5625 21.6875 13.125 23.75 13.125C25.8125 13.125 27.5 12.5625 27.5 11.875V10.625C27.5 11.3125 25.8125 11.875 23.75 11.875Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M23.75 13.75C21.6875 13.75 20 13.1875 20 12.5V13.75C20 14.4375 21.6875 15 23.75 15C25.8125 15 27.5 14.4375 27.5 13.75V12.5C27.5 13.1875 25.8125 13.75 23.75 13.75Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M23.75 15.625C21.6875 15.625 20 15.0625 20 14.375V15.625C20 16.3125 21.6875 16.875 23.75 16.875C25.8125 16.875 27.5 16.3125 27.5 15.625V14.375C27.5 15.0625 25.8125 15.625 23.75 15.625Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M23.75 17.5C21.6875 17.5 20 16.9375 20 16.25V17.5C20 18.1875 21.6875 18.75 23.75 18.75C25.8125 18.75 27.5 18.1875 27.5 17.5V16.25C27.5 16.9375 25.8125 17.5 23.75 17.5Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M23.75 19.375C21.6875 19.375 20 18.8125 20 18.125V19.375C20 20.0625 21.6875 20.625 23.75 20.625C25.8125 20.625 27.5 20.0625 27.5 19.375V18.125C27.5 18.8125 25.8125 19.375 23.75 19.375Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M23.75 21.25C21.6875 21.25 20 20.6875 20 20V21.25C20 21.9375 21.6875 22.5 23.75 22.5C25.8125 22.5 27.5 21.9375 27.5 21.25V20C27.5 20.6875 25.8125 21.25 23.75 21.25Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M23.75 23.125C21.6875 23.125 20 22.5625 20 21.875V23.125C20 23.8125 21.6875 24.375 23.75 24.375C25.8125 24.375 27.5 23.8125 27.5 23.125V21.875C27.5 22.5625 25.8125 23.125 23.75 23.125Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M23.75 25C21.6875 25 20 24.4375 20 23.75V25C20 25.6875 21.6875 26.25 23.75 26.25C25.8125 26.25 27.5 25.6875 27.5 25V23.75C27.5 24.4375 25.8125 25 23.75 25Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M23.75 6.25C25.8211 6.25 27.5 5.69036 27.5 5C27.5 4.30964 25.8211 3.75 23.75 3.75C21.6789 3.75 20 4.30964 20 5C20 5.69036 21.6789 6.25 23.75 6.25Z"
                              fill="#FB8500"
                            />
                            <path
                              d="M23.75 7.5C22 7.5 20.5625 7.125 20.125 6.5625C20.0625 6.6875 20 6.75 20 6.875C20 7.5625 21.6875 8.125 23.75 8.125C25.8125 8.125 27.5 7.5625 27.5 6.875C27.5 6.75 27.4375 6.6875 27.375 6.5625C26.9375 7.125 25.5 7.5 23.75 7.5ZM23.75 9.375C22 9.375 20.5625 9 20.125 8.4375C20.0625 8.5625 20 8.625 20 8.75C20 9.4375 21.6875 10 23.75 10C25.8125 10 27.5 9.4375 27.5 8.75C27.5 8.625 27.4375 8.5625 27.375 8.4375C26.9375 9 25.5 9.375 23.75 9.375ZM23.75 11.25C22 11.25 20.5625 10.875 20.125 10.3125C20.0625 10.4375 20 10.5 20 10.625C20 11.3125 21.6875 11.875 23.75 11.875C25.8125 11.875 27.5 11.3125 27.5 10.625C27.5 10.5 27.4375 10.4375 27.375 10.3125C26.9375 10.875 25.5 11.25 23.75 11.25ZM23.75 13.125C22 13.125 20.5625 12.75 20.125 12.1875C20.0625 12.3125 20 12.375 20 12.5C20 13.1875 21.6875 13.75 23.75 13.75C25.8125 13.75 27.5 13.1875 27.5 12.5C27.5 12.375 27.4375 12.3125 27.375 12.1875C26.9375 12.75 25.5 13.125 23.75 13.125ZM23.75 15C22 15 20.5625 14.625 20.125 14.0625C20.0625 14.1875 20 14.25 20 14.375C20 15.0625 21.6875 15.625 23.75 15.625C25.8125 15.625 27.5 15.0625 27.5 14.375C27.5 14.25 27.4375 14.1875 27.375 14.0625C26.9375 14.625 25.5 15 23.75 15ZM23.75 16.875C22 16.875 20.5625 16.5 20.125 15.9375C20.0625 16.0625 20 16.125 20 16.25C20 16.9375 21.6875 17.5 23.75 17.5C25.8125 17.5 27.5 16.9375 27.5 16.25C27.5 16.125 27.4375 16.0625 27.375 15.9375C26.9375 16.5 25.5 16.875 23.75 16.875ZM23.75 18.75C22 18.75 20.5625 18.375 20.125 17.8125C20.0625 17.9375 20 18 20 18.125C20 18.8125 21.6875 19.375 23.75 19.375C25.8125 19.375 27.5 18.8125 27.5 18.125C27.5 18 27.4375 17.9375 27.375 17.8125C26.9375 18.375 25.5 18.75 23.75 18.75ZM23.75 20.625C22 20.625 20.5625 20.25 20.125 19.6875C20.0625 19.8125 20 19.875 20 20C20 20.6875 21.6875 21.25 23.75 21.25C25.8125 21.25 27.5 20.6875 27.5 20C27.5 19.875 27.4375 19.8125 27.375 19.6875C26.9375 20.25 25.5 20.625 23.75 20.625ZM23.75 22.5C22 22.5 20.5625 22.125 20.125 21.5625C20.0625 21.6875 20 21.75 20 21.875C20 22.5625 21.6875 23.125 23.75 23.125C25.8125 23.125 27.5 22.5625 27.5 21.875C27.5 21.75 27.4375 21.6875 27.375 21.5625C26.9375 22.125 25.5 22.5 23.75 22.5ZM23.75 24.375C22 24.375 20.5625 24 20.125 23.4375C20.0625 23.5625 20 23.625 20 23.75C20 24.4375 21.6875 25 23.75 25C25.8125 25 27.5 24.4375 27.5 23.75C27.5 23.625 27.4375 23.5625 27.375 23.4375C26.9375 24 25.5 24.375 23.75 24.375Z"
                              fill="#FB8500"
                            />
                            <path
                              d="M6.25 11.875C4.1875 11.875 2.5 11.3125 2.5 10.625V11.875C2.5 12.5625 4.1875 13.125 6.25 13.125C8.3125 13.125 10 12.5625 10 11.875V10.625C10 11.3125 8.3125 11.875 6.25 11.875Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M6.25 10C4.1875 10 2.5 9.4375 2.5 8.75V10C2.5 10.6875 4.1875 11.25 6.25 11.25C8.3125 11.25 10 10.6875 10 10V8.75C10 9.4375 8.3125 10 6.25 10ZM6.25 13.75C4.1875 13.75 2.5 13.1875 2.5 12.5V13.75C2.5 14.4375 4.1875 15 6.25 15C8.3125 15 10 14.4375 10 13.75V12.5C10 13.1875 8.3125 13.75 6.25 13.75Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M6.25 15.625C4.1875 15.625 2.5 15.0625 2.5 14.375V15.625C2.5 16.3125 4.1875 16.875 6.25 16.875C8.3125 16.875 10 16.3125 10 15.625V14.375C10 15.0625 8.3125 15.625 6.25 15.625Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M6.25 17.5C4.1875 17.5 2.5 16.9375 2.5 16.25V17.5C2.5 18.1875 4.1875 18.75 6.25 18.75C8.3125 18.75 10 18.1875 10 17.5V16.25C10 16.9375 8.3125 17.5 6.25 17.5Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M6.25 19.375C4.1875 19.375 2.5 18.8125 2.5 18.125V19.375C2.5 20.0625 4.1875 20.625 6.25 20.625C8.3125 20.625 10 20.0625 10 19.375V18.125C10 18.8125 8.3125 19.375 6.25 19.375Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M6.25 21.25C4.1875 21.25 2.5 20.6875 2.5 20V21.25C2.5 21.9375 4.1875 22.5 6.25 22.5C8.3125 22.5 10 21.9375 10 21.25V20C10 20.6875 8.3125 21.25 6.25 21.25Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M6.25 23.125C4.1875 23.125 2.5 22.5625 2.5 21.875V23.125C2.5 23.8125 4.1875 24.375 6.25 24.375C8.3125 24.375 10 23.8125 10 23.125V21.875C10 22.5625 8.3125 23.125 6.25 23.125Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M6.25 25C4.1875 25 2.5 24.4375 2.5 23.75V25C2.5 25.6875 4.1875 26.25 6.25 26.25C8.3125 26.25 10 25.6875 10 25V23.75C10 24.4375 8.3125 25 6.25 25Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M6.25 10C8.32107 10 10 9.44036 10 8.75C10 8.05964 8.32107 7.5 6.25 7.5C4.17893 7.5 2.5 8.05964 2.5 8.75C2.5 9.44036 4.17893 10 6.25 10Z"
                              fill="#FB8500"
                            />
                            <path
                              d="M6.25 11.25C4.5 11.25 3.0625 10.875 2.625 10.3125C2.5625 10.4375 2.5 10.5 2.5 10.625C2.5 11.3125 4.1875 11.875 6.25 11.875C8.3125 11.875 10 11.3125 10 10.625C10 10.5 9.9375 10.4375 9.875 10.3125C9.4375 10.875 8 11.25 6.25 11.25ZM6.25 13.125C4.5 13.125 3.0625 12.75 2.625 12.1875C2.5625 12.3125 2.5 12.375 2.5 12.5C2.5 13.1875 4.1875 13.75 6.25 13.75C8.3125 13.75 10 13.1875 10 12.5C10 12.375 9.9375 12.3125 9.875 12.1875C9.4375 12.75 8 13.125 6.25 13.125ZM6.25 15C4.5 15 3.0625 14.625 2.625 14.0625C2.5625 14.1875 2.5 14.25 2.5 14.375C2.5 15.0625 4.1875 15.625 6.25 15.625C8.3125 15.625 10 15.0625 10 14.375C10 14.25 9.9375 14.1875 9.875 14.0625C9.4375 14.625 8 15 6.25 15ZM6.25 16.875C4.5 16.875 3.0625 16.5 2.625 15.9375C2.5625 16.0625 2.5 16.125 2.5 16.25C2.5 16.9375 4.1875 17.5 6.25 17.5C8.3125 17.5 10 16.9375 10 16.25C10 16.125 9.9375 16.0625 9.875 15.9375C9.4375 16.5 8 16.875 6.25 16.875ZM6.25 18.75C4.5 18.75 3.0625 18.375 2.625 17.8125C2.5625 17.9375 2.5 18 2.5 18.125C2.5 18.8125 4.1875 19.375 6.25 19.375C8.3125 19.375 10 18.8125 10 18.125C10 18 9.9375 17.9375 9.875 17.8125C9.4375 18.375 8 18.75 6.25 18.75ZM6.25 20.625C4.5 20.625 3.0625 20.25 2.625 19.6875C2.5625 19.8125 2.5 19.875 2.5 20C2.5 20.6875 4.1875 21.25 6.25 21.25C8.3125 21.25 10 20.6875 10 20C10 19.875 9.9375 19.8125 9.875 19.6875C9.4375 20.25 8 20.625 6.25 20.625ZM6.25 22.5C4.5 22.5 3.0625 22.125 2.625 21.5625C2.5625 21.6875 2.5 21.75 2.5 21.875C2.5 22.5625 4.1875 23.125 6.25 23.125C8.3125 23.125 10 22.5625 10 21.875C10 21.75 9.9375 21.6875 9.875 21.5625C9.4375 22.125 8 22.5 6.25 22.5ZM6.25 24.375C4.5 24.375 3.0625 24 2.625 23.4375C2.5625 23.5625 2.5 23.625 2.5 23.75C2.5 24.4375 4.1875 25 6.25 25C8.3125 25 10 24.4375 10 23.75C10 23.625 9.9375 23.5625 9.875 23.4375C9.4375 24 8 24.375 6.25 24.375Z"
                              fill="#FB8500"
                            />
                            <path
                              d="M15 17.5C12.9375 17.5 11.25 16.9375 11.25 16.25V17.5C11.25 18.1875 12.9375 18.75 15 18.75C17.0625 18.75 18.75 18.1875 18.75 17.5V16.25C18.75 16.9375 17.0625 17.5 15 17.5Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M15 15.625C12.9375 15.625 11.25 15.0625 11.25 14.375V15.625C11.25 16.3125 12.9375 16.875 15 16.875C17.0625 16.875 18.75 16.3125 18.75 15.625V14.375C18.75 15.0625 17.0625 15.625 15 15.625ZM15 19.375C12.9375 19.375 11.25 18.8125 11.25 18.125V19.375C11.25 20.0625 12.9375 20.625 15 20.625C17.0625 20.625 18.75 20.0625 18.75 19.375V18.125C18.75 18.8125 17.0625 19.375 15 19.375Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M15 21.25C12.9375 21.25 11.25 20.6875 11.25 20V21.25C11.25 21.9375 12.9375 22.5 15 22.5C17.0625 22.5 18.75 21.9375 18.75 21.25V20C18.75 20.6875 17.0625 21.25 15 21.25Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M15 23.125C12.9375 23.125 11.25 22.5625 11.25 21.875V23.125C11.25 23.8125 12.9375 24.375 15 24.375C17.0625 24.375 18.75 23.8125 18.75 23.125V21.875C18.75 22.5625 17.0625 23.125 15 23.125Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M15 25C12.9375 25 11.25 24.4375 11.25 23.75V25C11.25 25.6875 12.9375 26.25 15 26.25C17.0625 26.25 18.75 25.6875 18.75 25V23.75C18.75 24.4375 17.0625 25 15 25Z"
                              fill="#FFB703"
                            />
                            <path
                              d="M15 15.625C17.0711 15.625 18.75 15.0654 18.75 14.375C18.75 13.6846 17.0711 13.125 15 13.125C12.9289 13.125 11.25 13.6846 11.25 14.375C11.25 15.0654 12.9289 15.625 15 15.625Z"
                              fill="#FB8500"
                            />
                            <path
                              d="M15 16.875C13.25 16.875 11.8125 16.5 11.375 15.9375C11.3125 16.0625 11.25 16.125 11.25 16.25C11.25 16.9375 12.9375 17.5 15 17.5C17.0625 17.5 18.75 16.9375 18.75 16.25C18.75 16.125 18.6875 16.0625 18.625 15.9375C18.1875 16.5 16.75 16.875 15 16.875ZM15 18.75C13.25 18.75 11.8125 18.375 11.375 17.8125C11.3125 17.9375 11.25 18 11.25 18.125C11.25 18.8125 12.9375 19.375 15 19.375C17.0625 19.375 18.75 18.8125 18.75 18.125C18.75 18 18.6875 17.9375 18.625 17.8125C18.1875 18.375 16.75 18.75 15 18.75ZM15 20.625C13.25 20.625 11.8125 20.25 11.375 19.6875C11.3125 19.8125 11.25 19.875 11.25 20C11.25 20.6875 12.9375 21.25 15 21.25C17.0625 21.25 18.75 20.6875 18.75 20C18.75 19.875 18.6875 19.8125 18.625 19.6875C18.1875 20.25 16.75 20.625 15 20.625ZM15 22.5C13.25 22.5 11.8125 22.125 11.375 21.5625C11.3125 21.6875 11.25 21.75 11.25 21.875C11.25 22.5625 12.9375 23.125 15 23.125C17.0625 23.125 18.75 22.5625 18.75 21.875C18.75 21.75 18.6875 21.6875 18.625 21.5625C18.1875 22.125 16.75 22.5 15 22.5ZM15 24.375C13.25 24.375 11.8125 24 11.375 23.4375C11.3125 23.5625 11.25 23.625 11.25 23.75C11.25 24.4375 12.9375 25 15 25C17.0625 25 18.75 24.4375 18.75 23.75C18.75 23.625 18.6875 23.5625 18.625 23.4375C18.1875 24 16.75 24.375 15 24.375Z"
                              fill="#FB8500"
                            />
                          </svg>
                        </div>
                        <div className="ct_mt_30">
                          <h4 className="ct_fs_24_new text-white mb-3">
                            Sales
                          </h4>
                          <a
                            className="ct_yellow_text"
                            onClick={() =>
                              navigate(enterPrisesPaths?.SalesService)
                            }
                          >
                            View All{" "}
                            <i class="fa-solid fa-arrow-right ms-2"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xl-3 col-lg-3 col-md-6 mb-4 mb-lg-0"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <div className="ct_opportunity_card">
                        <div>
                          <svg
                            width="30"
                            height="30"
                            viewBox="0 0 30 30"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M22.5 25.8755C22.5 26.1739 22.3815 26.46 22.1705 26.671C21.9595 26.882 21.6734 27.0005 21.375 27.0005C21.0766 27.0005 20.7905 26.882 20.5795 26.671C20.3685 26.46 20.25 26.1739 20.25 25.8755V7.01753L18.0795 9.38603C17.9796 9.49496 17.8593 9.58316 17.7253 9.64558C17.5914 9.708 17.4464 9.74342 17.2988 9.74983C17.0006 9.76277 16.7095 9.65673 16.4895 9.45503C16.3806 9.35516 16.2924 9.23481 16.23 9.10086C16.1675 8.9669 16.1321 8.82197 16.1257 8.67432C16.1128 8.37614 16.2188 8.08503 16.4205 7.86503L20.5455 3.36503C20.6509 3.24999 20.7791 3.15813 20.9219 3.09529C21.0647 3.03245 21.219 3 21.375 3C21.531 3 21.6853 3.03245 21.8281 3.09529C21.9709 3.15813 22.0991 3.24999 22.2045 3.36503L26.3295 7.86503C26.5312 8.08503 26.6372 8.37614 26.6243 8.67432C26.6114 8.9725 26.4805 9.25333 26.2605 9.45503C26.0405 9.65673 25.7494 9.76277 25.4512 9.74983C25.153 9.73689 24.8722 9.60603 24.6705 9.38603L22.5 7.01753V25.8755ZM4.125 24.7505C3.82663 24.7505 3.54048 24.632 3.3295 24.421C3.11853 24.21 3 23.9239 3 23.6255C3 23.3272 3.11853 23.041 3.3295 22.83C3.54048 22.6191 3.82663 22.5005 4.125 22.5005H16.875C17.1734 22.5005 17.4595 22.6191 17.6705 22.83C17.8815 23.041 18 23.3272 18 23.6255C18 23.9239 17.8815 24.21 17.6705 24.421C17.4595 24.632 17.1734 24.7505 16.875 24.7505H4.125ZM7.5 19.1255C7.5 19.7465 8.004 20.2505 8.625 20.2505H16.875C17.1734 20.2505 17.4595 20.132 17.6705 19.921C17.8815 19.71 18 19.4239 18 19.1255C18 18.8272 17.8815 18.541 17.6705 18.33C17.4595 18.1191 17.1734 18.0005 16.875 18.0005H8.625C8.32663 18.0005 8.04048 18.1191 7.8295 18.33C7.61853 18.541 7.5 18.8272 7.5 19.1255ZM13.125 15.7505C12.8266 15.7505 12.5405 15.632 12.3295 15.421C12.1185 15.21 12 14.9239 12 14.6255C12 14.3272 12.1185 14.041 12.3295 13.83C12.5405 13.6191 12.8266 13.5005 13.125 13.5005H16.875C17.1734 13.5005 17.4595 13.6191 17.6705 13.83C17.8815 14.041 18 14.3272 18 14.6255C18 14.9239 17.8815 15.21 17.6705 15.421C17.4595 15.632 17.1734 15.7505 16.875 15.7505H13.125Z"
                              fill="#FFB703"
                            />
                          </svg>
                        </div>
                        <div className="ct_mt_30">
                          <h4 className="ct_fs_24_new text-white mb-3">
                            UI/UX Design
                          </h4>
                          <a
                            className="ct_yellow_text"
                            onClick={() =>
                              navigate(enterPrisesPaths?.DesignService)
                            }
                          >
                            View All{" "}
                            <i class="fa-solid fa-arrow-right ms-2"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="ct_px_40 ct_py_130 ct_pb_80">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h4 className="ct_fs_32 mb-4 ct_darkblue_text">
                  Explore the Services That Drive Your Growth
                </h4>
                <p
                  className="mb-0 ct_fs_20 ct_darkblue_text"
                  style={{ maxWidth: "817px" }}
                >
                  Browse our full range of expert solutions across customer
                  service, sales, marketing, and tech all designed to meet your
                  unique business needs.
                </p>
              </div>
            </div>
            <div className="row ct_mt_60">
              <div className="col-md-6 ct_mb_50">
                <figure className="ct_explore_service_card_12">
                  <img src="../assets/img/explore_service_card_img_1.png" />
                  <figcaption className="ct_mt_16">
                    <h4 className="ct_fs_24_new ct_darkblue_text ct_mb_10">
                      Sales
                    </h4>
                    <p
                      className="mb-0 ct_minimise_cnt"
                      style={{ maxWidth: "500px" }}
                    >
                      Drive revenue growth with expert-led sales strategies and
                      pipeline management.
                    </p>
                    <div className="ct_mt_20">
                      <a
                        className="ct_darkblue_text"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(enterPrisesPaths?.SalesService);
                        }}
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-2"></i>
                      </a>
                    </div>
                  </figcaption>
                </figure>
              </div>
              <div className="col-md-6 ct_mb_50">
                <figure className="ct_explore_service_card_12">
                  <img src="../assets/img/explore_service_card_img_2.png" />
                  <figcaption className="ct_mt_16">
                    <h4 className="ct_fs_24_new ct_darkblue_text ct_mb_10">
                      Marketing
                    </h4>
                    <p
                      className="mb-0 ct_minimise_cnt"
                      style={{ maxWidth: "500px" }}
                    >
                      Boost your brand’s reach through digital campaigns,
                      content, and targeted marketing efforts.
                    </p>
                    <div className="ct_mt_20">
                      <a
                        className="ct_darkblue_text"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(enterPrisesPaths?.SalesService);
                        }}
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-2"></i>
                      </a>
                    </div>
                  </figcaption>
                </figure>
              </div>
              <div className="col-md-6 ct_mb_50">
                <figure className="ct_explore_service_card_12">
                  <img src="../assets/img/explore_service_card_img_3.png" />
                  <figcaption className="ct_mt_16">
                    <h4 className="ct_fs_24_new ct_darkblue_text ct_mb_10">
                      Customer Service
                    </h4>
                    <p
                      className="mb-0 ct_minimise_cnt"
                      style={{ maxWidth: "500px" }}
                    >
                      Deliver exceptional customer support that builds loyalty
                      and keeps clients happy.
                    </p>
                    <div className="ct_mt_20">
                      <a
                        className="ct_darkblue_text"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(enterPrisesPaths?.SalesService);
                        }}
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-2"></i>
                      </a>
                    </div>
                  </figcaption>
                </figure>
              </div>
              <div className="col-md-6 ct_mb_50">
                <figure className="ct_explore_service_card_12">
                  <img src="../assets/img/explore_service_card_img_4.png" />
                  <figcaption className="ct_mt_16">
                    <h4 className="ct_fs_24_new ct_darkblue_text ct_mb_10">
                      UI/UX Design
                    </h4>
                    <p
                      className="mb-0 ct_minimise_cnt"
                      style={{ maxWidth: "500px" }}
                    >
                      Create stunning, user-friendly websites that captivate and
                      convert visitors.
                    </p>
                    <div className="ct_mt_20">
                      <a
                        className="ct_darkblue_text"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(enterPrisesPaths?.SalesService);
                        }}
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-2"></i>
                      </a>
                    </div>
                  </figcaption>
                </figure>
              </div>
              <div className="col-md-6 ct_mb_50">
                <figure className="ct_explore_service_card_12">
                  <img src="../assets/img/explore_service_card_img_5.png" />
                  <figcaption className="ct_mt_16">
                    <h4 className="ct_fs_24_new ct_darkblue_text ct_mb_10">
                      Mobile Design
                    </h4>
                    <p
                      className="mb-0 ct_minimise_cnt"
                      style={{ maxWidth: "497px" }}
                    >
                      Design seamless mobile experiences that engage users and
                      elevate your product.
                    </p>
                    <div className="ct_mt_20">
                      <a
                        className="ct_darkblue_text"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(enterPrisesPaths?.SalesService);
                        }}
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-2"></i>
                      </a>
                    </div>
                  </figcaption>
                </figure>
              </div>
              <div className="col-md-6 ct_mb_50">
                <figure className="ct_explore_service_card_12">
                  <img src="../assets/img/explore_service_card_img_6.png" />
                  <figcaption className="ct_mt_16">
                    <h4 className="ct_fs_24_new ct_darkblue_text ct_mb_10">
                      Software Development
                    </h4>
                    <p
                      className="mb-0 ct_minimise_cnt"
                      style={{ maxWidth: "497px" }}
                    >
                      Build robust, scalable software solutions tailored to your
                      business goals.
                    </p>
                    <div className="ct_mt_20">
                      <a
                        className="ct_darkblue_text"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(enterPrisesPaths?.SalesService);
                        }}
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-2"></i>
                      </a>
                    </div>
                  </figcaption>
                </figure>
              </div>
              <div className="col-md-6 ct_mb_50">
                <figure className="ct_explore_service_card_12">
                  <img src="../assets/img/explore_service_card_img_7.png" />
                  <figcaption className="ct_mt_16">
                    <h4 className="ct_fs_24_new ct_darkblue_text ct_mb_10">
                      Product Management
                    </h4>
                    <p
                      className="mb-0 ct_minimise_cnt"
                      style={{ maxWidth: "497px" }}
                    >
                      Streamline your product’s journey from idea to launch with
                      expert product managers.
                    </p>
                    <div className="ct_mt_20">
                      <a
                        className="ct_darkblue_text"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate(enterPrisesPaths?.SalesService);
                        }}
                      >
                        Learn More <i class="fa-solid fa-arrow-right ms-2"></i>
                      </a>
                    </div>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </section>
        <section
          class="ct_looking_for_work_bg      ct_p_111_y_106"
          style={{ backgroundColor: "#219EBC" }}
        >
          <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
            <div class="text-white">
              <h4 class="ct_fs_36 mb-4 text-white">
                Personalized Coaching, Real Results
              </h4>
              <p class="mb-0 ct_fs_18" style={{ maxWidth: "631px" }}>
                Get expert guidance through Coach Hub where your team learns,
                grows, and sells smarter with hands-on support tailored to your
                business goals.
              </p>
            </div>
            <div class="ct_flex_shrink_0">
              <a
                class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(coachPaths?.WebinarLandingPage);
                }}
              >
                Explore CoachHub
              </a>
            </div>
          </div>
        </section>
        <section className="ct_px_40 ct_py_130">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 mb-4 mb-md-0">
                <div>
                  <img
                    src="../assets/img/explore_service_signle_img_1.png"
                    className="ct_img_h_480 ct_object_cover"
                  />
                </div>
              </div>
              <div className="col-md-6 mb-4 mb-md-0">
                <div>
                  <img
                    src="../assets/img/explore_service_signle_img_2.png"
                    className="ct_img_h_480"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class=" ct_px_40 ct_py_130">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div
                class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                data-aos="fade-right"
                data-aos-duration="1500"
              >
                <div class="ct_how_work_img">
                  <img
                    src="../assets/img/coach_works_img.png"
                    alt=""
                    style={{ objectFit: "cover", objectPosition: "right" }}
                  />
                </div>
              </div>
              <div
                class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <div class="ct_how_work_content">
                  <h4 class="ct_fs_24 ct_darkblue_text">Why Choose Nuvio?</h4>
                  <h3 class="ct_fs_32 ct_darkblue_text ">
                    Smart tools, top talent, and support all in one place.
                  </h3>
                </div>
                <div class="row mt-5">
                  <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                    <div class="ct_how_work_card">
                      <img
                        src="../assets/img/ri_find-replace-fill.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                      <div class="pt-4">
                        <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                          Trusted by Professionals
                        </h5>
                        <p class="mb-0 ct_fs_16" style={{ maxWidth: "260px" }}>
                          Join a growing network of businesses and freelancers
                          who rely on Nuvio to find the right match, every time.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                    <div class="ct_how_work_card">
                      <img
                        src="../assets/img/work_icon_2.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                      <div class="pt-4">
                        <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                          Built for Simplicity
                        </h5>
                        <p class="mb-0 ct_fs_16" style={{ maxWidth: "260px" }}>
                          Our platform is designed to save you time with
                          intuitive tools and hands-on support when you need it.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                    <div class="ct_how_work_card">
                      <img
                        src="../assets/img/uim_bag.png"
                        alt=""
                        className="ct_w_50_340"
                      />
                      <div class="pt-4">
                        <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                          Start in Minutes
                        </h5>
                        <p class="mb-0 ct_fs_16" style={{ maxWidth: "260px" }}>
                          Whether you're hiring or offering your skills, getting
                          started is quick and effortless with flexible plans.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          class="ct_looking_for_work_bg  ct_looking_for_work_bg_left    ct_p_111_y_106"
          style={{ backgroundColor: "var(--orange)" }}
        >
          <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
            <div class="text-white">
              <h4 class="ct_fs_36 mb-4 text-white">
                Let’s Make Magic Together
              </h4>
              <p class="mb-0 ct_fs_18" style={{ maxWidth: "632px" }}>
                Big ideas, bold moves, and all the support you need we’re here
                to help you shine.
              </p>
            </div>
            <div class="ct_flex_shrink_0">
              <a
                class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(coachPaths?.ContactUs, {
                    state: { data: "landing" },
                  });
                }}
              >
                Talk to Us
              </a>
            </div>
          </div>
        </section>
        <section
          class=" ct_story_light_bg ct_px_40 ct_mt_130 ct_mb_100"
          style={{ backgroundColor: "hsl(199deg 64% 73% / 50%)" }}
        >
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-4 mb-4 mb-lg-0">
                <div class="d-grid h-100 pt-2 pb-5">
                  <h2 class="ct_fs_40">
                    Real Stories, real{" "}
                    <span class="ct_yellow_text">success</span>
                  </h2>
                  <div class="ct_arrows mt-auto d-none d-lg-flex ">
                    <button class="ct_arrow_btn ct_prev" ref={prevRef}>
                      <i class="fa-solid fa-arrow-left"></i>
                    </button>
                    <button class="ct_arrow_btn ct_next" ref={nextRef}>
                      <i class="fa-solid fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-lg-8 mb-4 mb-lg-0">
                <Swiper
                  modules={[Navigation, Autoplay]}
                  spaceBetween={20}
                  slidesPerView={1}
                  loop={true}
                  autoplay={{ delay: 2500 }}
                  navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                  }}
                  className="ct_real_stories_slider"
                >
                  {/* Slide 1 */}
                  <SwiperSlide>
                    <div class="ct_story_slide_card">
                      <div class="ct_story_user_img">
                        <img
                          src="../assets/img/real_succss_img_457.png"
                          alt=""
                        />
                      </div>
                      <div>
                        <div class="ct_orange_text mb-3">
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                        </div>
                        <h3 class="ct_fs_20 mb-3">
                          Climbing Higher with Every Project
                        </h3>
                        <p
                          class="ct_fS_18 ct_max_w_100_767"
                          style={{ maxWidth: " 402px" }}
                        >
                          NuStar gave me access to exclusive projects that truly
                          challenged and grew my expertise. Today, I lead
                          innovative product initiatives and mentor upcoming
                          tech talents.
                        </p>
                        <div class="mt-5">
                          <h4 class="ct_fs_20">Chloe Adams</h4>
                          <p class="ct_fs_18">
                            Product Director at Zenith Tech
                          </p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  {/* <SwiperSlide>
                    <div class="ct_story_slide_card">
                      <div class="ct_story_user_img">
                        <img src="../assets/img/story_img_user.png" alt="" />
                      </div>

                      <div>
                        <div class="ct_orange_text mb-3">
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                        </div>
                        <h3 class="ct_fs_20 mb-3">
                          Climbing Higher with Every Project
                        </h3>
                        <p class="ct_fS_18" style={{ maxWidth: " 402px" }}>
                          NuStar gave me access to exclusive projects that truly
                          challenged and grew my expertise. Today, I lead
                          innovative product initiatives and mentor upcoming
                          tech talents.
                        </p>
                        <div class="mt-5">
                          <h4 class="ct_fs_20">Chloe Adams</h4>
                          <p class="ct_fs_18">
                            Product Director at Zenith Tech
                          </p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide> */}
                  <SwiperSlide>
                    <div class="ct_story_slide_card">
                      <div class="ct_story_user_img">
                        <img src="../assets/img/story_img_user.png" alt="" />
                      </div>

                      <div>
                        <div class="ct_orange_text mb-3">
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                          <i class="fa-solid fa-star"></i>
                        </div>
                        <h3 class="ct_fs_20 mb-3">
                          Climbing Higher with Every Project
                        </h3>
                        <p class="ct_fS_18" style={{ maxWidth: " 402px" }}>
                          NuStar gave me access to exclusive projects that truly
                          challenged and grew my expertise. Today, I lead
                          innovative product initiatives and mentor upcoming
                          tech talents.
                        </p>
                        <div class="mt-5">
                          <h4 class="ct_fs_20">Chloe Adams</h4>
                          <p class="ct_fs_18">
                            Product Director at Zenith Tech
                          </p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="ct_story_slide_card">
                      <div className="ct_story_user_img">
                        <img
                          src="../assets/img/reacl_stories_img_slider_123.png"
                          alt=""
                        />
                      </div>
                      <div>
                        <div className="ct_orange_text mb-3">
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>
                        </div>

                        <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                          From Passion to Profession
                        </h3>

                        <p
                          className="ct_fS_18 ct_darkblue_text"
                          style={{ maxWidth: "402px" }}
                        >
                          Starting as a freelance developer felt overwhelming.
                          But through NuGlow, I built a solid portfolio and
                          connected with startups that valued my work. Today, I
                          lead a team and help others find their way too.
                        </p>

                        <div className="mt-5">
                          <h4 className="ct_fs_20 ct_darkblue_text">
                            Amelia Carter
                          </h4>
                          <p className="ct_fs_18 ct_darkblue_text">
                            Head of Product at BrightWave Solutions
                          </p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </section>
        {/* <div style={{ height: "100px" }}></div> */}
      </MenuLayout>
    </div>
  );
};

export default ExploreService;
